import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs'
import { UserService } from '../../views/pages/auth/UserDetails/user.service';
import { Router } from '@angular/router';
import { retry } from 'rxjs/operators';
import { Notification } from '../Notifications/Notification';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: UserService, private router: Router, private Notify: Notification) { }

    // intercept(request: HttpRequest<any>, next: HttpHandler) {

    //     return next.handle(request)
    //         .pipe(
    //             catchError((error: HttpErrorResponse) => {
    //                 let errorMessage = '';
    //                 if (error.error instanceof ErrorEvent) {
    //                     // client-side error
    //                     errorMessage = `Error: ${error.error.message}`;
    //                 } 
    //                 else {
    //                     // server-side error
    //                    // errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
    //                     errorMessage = `Message: ${error.statusText}`;
    //                 }
    //                 if (error.status === 401) {
    //                     this.Notify.errorsmsg("Unauthorized Access")
    //                     this.authenticationService.logout();
    //                     this.router.navigate(['/auth/login']);
    //                 }
    //                 else {
    //                     this.Notify.errorsmsg(errorMessage);
    //                 }
    //                 return throwError(errorMessage);
    //             })
    //         )
    // }
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        console.log('Http request started');
        return next.handle(req)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    // console.log('data')
                    // console.log(error);
                    if (error.status == 400 && error.error.error_description !=undefined ) {
                        this.Notify.errorsmsg(error.error.error_description);
                    }
                    else if (error.status == 400 && error.error != undefined) {
                        console.log('API Error')
                        console.log(error.error)
                        this.Notify.errorsmsg(error.error);
                    }
                    else if (error.status == 400) {
                        console.log('API Error')
                        console.log(error.error)
                        this.Notify.errorsmsg("Duplicate value are not allowed");
                    }
                    else if (error.status == 404) {
                        console.log('Test')
                        console.log(error)
                        this.Notify.errorsmsg("Data not found");
                    }
                    else if (error.status == 404 && error.error==undefined) {
                        console.log(error.error.error_description)
                        this.Notify.errorsmsg("Data not found");
                    }
                    else if (error.status == 405) {
                        this.Notify.errorsmsg("The requested URL couldn't be found or that it was entered incorrectly");
                    }
                    else if (error.status == 500) {
                        this.Notify.errorsmsg("Contact admin vgsl@vikasglobal.net");
                    }
                    
                    // else {
                    //     this.Notify.errorsmsg(error.error)
                    // }
                    return throwError(error.error)
                })
            );

    }
}